

import { Box } from "@chakra-ui/react";

import ServiceTimePerServiceTable from "../../../components/organization/tables/ServiceTimePerServiceTable";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildDurationInsights } from "../../../store/reportEnterpriseInsights";
import { formatTime } from "../../../store/helpers";

const ServiceTimePerService = ({
  branchId = null,
  reportIndex,
  branchIndex,
  data,
  numServices=0,
  branchName=""
}) => {
  const insights = buildDurationInsights(data, {
    metric: "service",
    scopeLabel: "Service",
    formatDuration: formatTime,
  });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Service Handling Time Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <ServiceTimePerServiceTable
        branchId={branchId}
        data={data}
        numServices={numServices}
        branchName={branchName}
        reportIndex={reportIndex}
        branchIndex={branchIndex}
      />
    </Box>
  );
};

export default ServiceTimePerService;
